"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.PhoneSVG = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _Icon = require("../Icon");
var _excluded = ["children"];
var PhoneSVG = function PhoneSVG(_ref) {
  var children = _ref.children,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/_react.default.createElement("path", {
    stroke: "none",
    d: "M26.41,2.81,20.68,2a1.87,1.87,0,0,0-1.94,1.2l-2,6.2a1.78,1.78,0,0,0,.72,2l3.27,2.1c-.51,2.3-.82,4.7-5,7.6l-2.86-2.5a1.74,1.74,0,0,0-2.05-.3l-5.84,3.1a1.74,1.74,0,0,0-.81,2.1l1.84,5.4a1.74,1.74,0,0,0,1.84,1.2c13.93-1.4,21.4-11.9,20.07-25.8A1.53,1.53,0,0,0,26.41,2.81Z"
  }));
};
exports.PhoneSVG = PhoneSVG;
PhoneSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: _propTypes.default.node
} : {};
var _default = (0, _Icon.withIcon)(PhoneSVG);
exports.default = _default;